import React from 'react';
import { domToReact, attributesToProps } from 'html-react-parser';
import { Tags } from './Constants';
import { wpFootnoteClass } from '../toFootnote/Constants';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';

const toTypography = (parserData) => 
{
    const {
        parserOptions: { replaceFn },
    } = parserData;
    const Wrapper = (
        {
            name = parserPropTypesDefaults.name,
            type = parserPropTypesDefaults.type,
            attribs = parserPropTypesDefaults.attribs,
            children = parserPropTypesDefaults.children,
        },
        addToCollection = null
    ) => 
    {
        if (type !== 'tag') return null;
        if (!children) return null;
        if (!Tags.some((item) => item.tag === name)) return null;
        if (
            name === 'p' &&
            children.find((item) => item?.attribs?.class === wpFootnoteClass)
        )
            return null;

        const props = attributesToProps(attribs);

        if (props['data-testid']) 
        {
            props.testId = props['data-testid'];
        }

        if (name === 'h2') 
        {
            if (!children[0]?.data) 
            {
                return null;
            }
            let newId = children[0].data
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-');

            if (newId.endsWith('-')) 
            {
                newId = newId.slice(0, -1);
            }
            props.id = newId;
        }
        const { Component } = Tags.find((item) => item.tag === name);
        const childComponents = domToReact(children, replaceFn());
        if (name.includes('h')) addToCollection(`${name}`, childComponents);

        return <Component {...props}>{childComponents}</Component>;
    };
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
};

export default toTypography;
